import { IconName } from '@usealloy/component-library';
import type { BadgeProps } from '@usealloy/component-library';

/** Takes in a document's review status and returns appropriate badge props */
export const getDocReviewBadgeProps = (approvalStatus?: boolean): {
  label: string;
  status: BadgeProps['status'];
  iconName: BadgeProps['icon'];
} => {
  if (approvalStatus === true) {
    return {
      label: 'Approved',
      status: 'success',
      iconName: IconName.Approved,
    };
  }

  if (approvalStatus === false) {
    return {
      label: 'Denied',
      status: 'danger',
      iconName: IconName.Xmark,
    };
  }

  return {
    label: 'Unreviewed',
    status: 'attention',
    iconName: IconName.Review,
  };
};
